import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';

import { CustomQuestion } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ImmomioDropdown,
  ImmomioDropdownTrigger,
  ImmomioDropdownMenu,
  ImmomioDropdownGroup,
  ImmomioDropdownItem
} from '@immomio/ui/dropdown';
import { ImmomioIconButtonComponent } from '@immomio/ui/button';
import { CustomQuestionDetailsComponent } from '../custom-question-details/custom-question-details.component';

@Component({
  selector: 'app-custom-question',
  templateUrl: './custom-question.component.html',
  styleUrls: ['./custom-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImmomioDropdown,
    ImmomioDropdownTrigger,
    ImmomioDropdownMenu,
    ImmomioDropdownGroup,
    ImmomioDropdownItem,
    ImmomioIconButtonComponent,
    CustomQuestionDetailsComponent,
    TranslatePipe
  ]
})
export class CustomQuestionComponent {
  readonly showPreview = input(true);
  readonly customQuestion = input<CustomQuestion>(undefined);
  readonly delete = output<string>();
  readonly preview = output<CustomQuestion>();

  onPreview() {
    this.preview.emit(this.customQuestion());
  }

  onDelete() {
    this.delete.emit(this.customQuestion().id);
  }
}
